import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { MobileCallButton } from "../components/MobileCallButton";
import { Hero } from "../components/sections/Hero";
import { Intro } from "../components/sections/Intro";
import { Arrangementen } from "../components/sections/Arrangementen";
import { Themas } from "../components/sections/Themas";
import { Mogelijkheden } from "../components/sections/Mogelijkheden";
import { Waarom } from "../components/sections/Waarom";
import { Galerij } from "../components/sections/Galerij";
import { Praktisch } from "../components/sections/Praktisch";
import { Contact } from "../components/sections/Contact";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Arrangementen />
        <Themas />
        <Mogelijkheden />
        <Waarom />
        <Galerij />
        <Praktisch />
        <Contact />
      </main>
      <Footer />
      <MobileCallButton />
    </div>
  );
}
